<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import DonutChart from 'shared/components/charts/DonutChart.vue';
import Spinner from 'shared/components/Spinner.vue';

const props = defineProps({
  data: {
    type: Array,
    default: () => [],
  },
  loading: {
    type: Boolean,
    default: false,
  },
});

const { t } = useI18n();

const COLORS = [
  '#12A594',
  '#3E63DD',
  '#F76B15',
  '#E54666',
  '#8E4EC6',
  '#30A46C',
];

const chartData = computed(() => {
  if (!props.data || props.data.length === 0) {
    return { labels: [], datasets: [] };
  }
  return {
    labels: props.data.map(d => d.inbox_name || `Inbox ${d.inbox_id}`),
    datasets: [
      {
        data: props.data.map(d => d.count),
        backgroundColor: COLORS.slice(0, props.data.length),
        borderWidth: 0,
      },
    ],
  };
});
</script>

<template>
  <div
    class="flex flex-col rounded-xl shadow outline-1 outline outline-n-container bg-n-solid-2 px-6 py-5"
  >
    <h3 class="mb-4 text-sm font-medium text-n-slate-11">
      {{ t('CEO_DASHBOARD.BREAKDOWN.BY_CHANNEL') }}
    </h3>
    <div v-if="loading" class="flex items-center justify-center py-12">
      <Spinner />
    </div>
    <div
      v-else-if="data.length === 0"
      class="flex items-center justify-center py-12"
    >
      <span class="text-sm text-n-slate-10">
        {{ t('CEO_DASHBOARD.BREAKDOWN.NO_DATA') }}
      </span>
    </div>
    <div v-else class="h-64">
      <DonutChart :collection="chartData" />
    </div>
  </div>
</template>
